{
  "charts": [
    {
      "title": "bookings_per_usage_type_per_month",
      "channel": "SummaryPerMonth",
      "key": "bookingsPerUsageType",
      "type": "bar",
      "isStacked": true
    },
    {
      "title": "bookings_per_mail_address_per_month",
      "channel": "SummaryPerMonth",
      "key": "bookingsPerMembership",
      "type": "spline"
    },
    {
      "title": "total_bookings_per_month",
      "channel": "SummaryPerMonth",
      "key": "totalBooking",
      "type": "bar",
      "hideLegend": true
    },
    {
      "title": "total_distances_per_month",
      "channel": "SummaryPerMonth",
      "key": "totalDistance",
      "type": "spline",
      "hideLegend": true
    },
    {
      "title": "bookings_per_usage_type",
      "channel": "SummaryForAPeriod",
      "key": "bookingsPerUsageType",
      "type": "pie"
    },
    {
      "title": "distances_per_usage_type",
      "channel": "SummaryForAPeriod",
      "key": "distancesPerUsageType",
      "type": "pie"
    },
    {
      "title": "users_per_mail_address",
      "channel": "CountOfUsersPerMembership",
      "type": "pie"
    },
    {
      "title": "bookings_per_mail_address",
      "channel": "CountOfBookingsPerMembership",
      "type": "pie"
    },
    {
      "title": "carbonate_savings",
      "channel": "SummaryForAPeriod",
      "key": "co2SavingsToCarInKG",
      "type": "donut"
    }
  ]
}
